import React, { Component } from 'react';
import { connect } from 'react-redux';
import VendorList from './VendorList';
import VendorSave from './VendorSave';
import WithRouter from 'custom/withRouter';

class VendorPage extends Component {
    constructor(props, context) {
        super(props, context);
    }

    callListView = () => {
        this.props.navigate("/vendor");
    }

    callSaveView = () => {
        this.props.navigate("/vendor/add");
    }

    render() {
        const p = this.props;
        const vendorId = p.params.id;
        const isSave = vendorId || p.location.pathname === "/vendor/add";
        return (
            <div>
                {
                    isSave
                        ?
                        <VendorSave name="vendor" params={p.params} callListView={this.callListView} title="Vendor Info" />
                        :
                        <VendorList callAddVendorForm={this.callSaveView} title="Vendor List" />
                }
            </div>
        );
    }
}

function mapStatetoProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(WithRouter(VendorPage));